<template>
  <Site>
    <!-- PRELOADER -->
    <div id="preloader">
      <div class="loader_line"></div>
    </div>
    <!-- /PRELOADER -->

    <!-- WRAPPER ALL -->
    <div class="cavani_tm_all_wrap" data-magic-cursor="show" data-enter="fadeInUp" data-exit="">

      <!-- MODALBOX -->
      <div class="cavani_tm_modalbox">
        <div class="box_inner">
          <div class="close">
            <a href="#"><img class="svg" src="img/svg/cancel.svg" alt="" /></a>
          </div>
          <div class="description_wrap"></div>
        </div>
      </div>
      <!-- /MODALBOX -->

      <!-- HEADER -->
      <div class="cavani_tm_header">
        <div class="logo">
          <a href="#"><img :src="'site/images/logo_2024.png'" alt="" /></a>
        </div>
        <div class="menu">
          <ul class="transition_link">
            <li class="active"><a href="#home">Início</a></li>
            <li><a href="#about">Sobre</a></li>
            <li><a href="#parceiros">Parceiros</a></li>
            <li><a href="#anais">Anais</a></li>
            <li><a href="#ajuda">Ajuda & Downloads</a></li>
            <li><a href="/site/documentos/regulamentos/XIMostraAtt.pdf?v=1.5" target="_blank">Regulamentos</a></li>
            <li class="color-mostra"><a href="/app/" target="_blank" style="color: #FFF">Acesse o Sistema</a></li>
          </ul>
          <span class="ccc"></span>
        </div>
      </div>
      <!-- /HEADER -->

      <div class="cavani_tm_left_border"></div>
      <div class="cavani_tm_right_border"></div>

      <!-- MOBILE MENU -->
      <div class="cavani_tm_topbar">
        <div class="topbar_inner">
          <div class="logo">
            <a href="#"><img :src="'site/images/logo_2024.png'" alt="" /></a>
          </div>
          <div class="trigger">
            <div class="hamburger hamburger--slider">
              <div class="hamburger-box">
                <div class="hamburger-inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cavani_tm_mobile_menu">
        <div class="inner">
          <div class="wrapper">
<!--            <div class="avatar">-->
<!--              <div class="image" data-img-url="img/about/1.jpeg"></div>-->
<!--            </div>-->
            <div class="menu_list">
              <ul class="transition_link">
                <li class="active"><a href="#home">Início</a></li>
                <li><a href="#about">Sobre</a></li>
                <li><a href="#parceiros">Parceiros</a></li>
                <li><a href="#anais">Anais</a></li>
                <li><a href="#ajuda">Ajuda & Downloads</a></li>
                <li><a href="/site/documentos/regulamentos/XIMostraAtt.pdf?v=1.5" target="_blank">Regulamentos</a></li>
                <li><a href="/app/projetos/novo" target="_blank">Pré-Inscrição</a></li>
              </ul>
            </div>
            <div class="social">
              <ul>
                <li><a href="#"><img class="svg" src="img/svg/social/facebook.svg" alt="" /></a></li>
                <li><a href="#"><img class="svg" src="img/svg/social/linkedin.svg" alt="" /></a></li>
                <li><a href="#"><img class="svg" src="img/svg/social/instagram.svg" alt="" /></a></li>
              </ul>
            </div>
            <div class="copyright">
              <p>Copyright &copy; 2023</p>
            </div>
          </div>
        </div>
      </div>

      <!-- /MOBILE MENU -->

      <!-- MAINPART -->
      <div class="cavani_tm_mainpart">
        <div class="author_image">
          <div class="main" data-img-url="img/about/2024.jpeg?v=1.0"></div>
        </div>
        <div class="main_content">
          <home></home>
          <sobre></sobre>
          <parceiros></parceiros>
          <anais></anais>
          <ajuda></ajuda>
        </div>
      </div>
      <!-- /MAINPART -->

      <!-- FOOTER -->
      <div class="cavani_tm_footer">
        <div class="copyright">
          <p>Copyright &copy; 2023</p>
        </div>
        <div class="social">
          <ul>
            <li><a href="#"><img class="svg" src="img/svg/social/facebook.svg" alt="" /></a></li>
            <li><a href="#"><img class="svg" src="img/svg/social/linkedin.svg" alt="" /></a></li>
            <li><a href="#"><img class="svg" src="img/svg/social/instagram.svg" alt="" /></a></li>
          </ul>
        </div>
      </div>
      <!-- /FOOTER -->

      <div class="mouse-cursor cursor-outer"></div>
      <div class="mouse-cursor cursor-inner"></div>
    </div>
  </Site>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Site from "./Template/Site";
import Home from "./Pages/Home";
import Sobre from "./Pages/Sobre";
import Parceiros from "./Pages/Parceiros";
import Anais from "./Pages/Anais";
import Ajuda from "./Pages/Ajuda";

export default {
  components: {
    Anais,
    Ajuda,
    Parceiros,
    Link,
    Site,
    Home,
    Sobre
  }
}
</script>
